module.exports = __webpack_public_path__ + "img/Zucker.828612d9.png";